export const DEFAULT_APPROBATIONS_CONFIG = {
  auto_escalation: '24',
  default_priority: 'normal',
  email_notifications: true,
  sla_hours: '48',
  require_comment_on_reject: true,
  itemsPerPage: 50,
};

export function normalizeApprobationsConfig(raw = {}) {
  const merged = { ...DEFAULT_APPROBATIONS_CONFIG, ...(raw || {}) };
  const itemsPerPage = parseInt(merged.itemsPerPage, 10);
  return {
    auto_escalation: String(merged.auto_escalation ?? DEFAULT_APPROBATIONS_CONFIG.auto_escalation),
    default_priority: merged.default_priority || DEFAULT_APPROBATIONS_CONFIG.default_priority,
    email_notifications: merged.email_notifications !== false,
    sla_hours: String(merged.sla_hours ?? DEFAULT_APPROBATIONS_CONFIG.sla_hours),
    require_comment_on_reject: merged.require_comment_on_reject !== false,
    itemsPerPage: Number.isFinite(itemsPerPage) && itemsPerPage > 0 ? itemsPerPage : DEFAULT_APPROBATIONS_CONFIG.itemsPerPage,
  };
}

/** Cap list rows to configured itemsPerPage. */
export function sliceApprobationsListItems(items = [], itemsPerPage = 50) {
  const limit = Math.max(1, parseInt(itemsPerPage, 10) || 50);
  return (Array.isArray(items) ? items : []).slice(0, limit);
}
